import {ControlledSelect} from '@hm/fundamental'
import {Control, Controller, FieldValues, Path, RegisterOptions} from 'react-hook-form'

export type SelectOption = {
  label: string
  value: string
}

interface ControlledSelectFieldProps<TField extends FieldValues> {
  control: Control<TField>
  formDataName: Path<TField>
  rules?: RegisterOptions<TField>
  label: string
  options: SelectOption[]
  disabled?: boolean
  className?: string
  dataTestId?: string
}

export const ControlledSelectField = <TField extends FieldValues>({
  control,
  formDataName,
  rules,
  label,
  options,
  disabled,
  className,
  dataTestId
}: ControlledSelectFieldProps<TField>) => (
  <Controller
    control={control}
    name={formDataName}
    rules={rules}
    render={({field, fieldState}) => (
      <ControlledSelect
        name={field.name}
        value={field.value || ''}
        label={label}
        values={options}
        onChange={(value) => {
          field.onChange(value || '')
        }}
        onBlur={field.onBlur}
        isDisabled={disabled}
        isTouched={fieldState.isTouched}
        error={fieldState.error?.message}
        className={className}
        data-test-id={dataTestId}
      />
    )}
  />
)
